export const START_FETCHING_EVENTS = 'redux/events/START_FETCHING_EVENTS';
export const SUCCESS_FETCHING_EVENTS = 'redux/events/SUCCESS_FETCHING_EVENTS';
export const ERROR_FETCHING_EVENTS = 'redux/events/ERROR_FETCHING_EVENTS';
export const SET_KEYWORD = 'redux/events/SET_KEYWORD';
export const SET_CATEGORY = 'redux/events/SET_CATEGORY';
export const SET_TALENT = 'redux/events/SET_TALENT';